import type { MansionDef, FloorId } from './types';
import { GROUND } from './floors/ground';
import { BASEMENT } from './floors/basement';
import { SECOND } from './floors/second';
import { THIRD } from './floors/third';
import { ATTIC } from './floors/attic';
import { buildFloor, type Floor } from './builder';

export function mansionDef(): MansionDef {
  return { floors: [BASEMENT, GROUND, SECOND, THIRD, ATTIC] };
}

export class Mansion {
  floors = new Map<FloorId, Floor>();
  constructor(def: MansionDef, seed: number) {
    for (const fd of def.floors) this.floors.set(fd.id, buildFloor(fd, seed));
  }
  get(id: FloorId): Floor {
    const f = this.floors.get(id);
    if (!f) throw new Error('no floor ' + id);
    return f;
  }
}
